import { Five9Client } from './client';
import { forOwn } from 'lodash';
import SetCallVariableFlow from './set-call-variable-flow';

export default function SetSecurePayCardDetailsFlow(ccInfo, client = new Five9Client()){
  let promises = [];
  forOwn(ccInfo, (value, key) => {
    promises.push( SetCallVariableFlow("SecurePay", key, value, client) )
  });
  return Promise.all(promises);
}
window.SetSecurePayCardDetailsFlow = SetSecurePayCardDetailsFlow;
